module.exports = __webpack_public_path__ + "static/logo-4fac9e886b51e82795189876e47865e9.svg";